import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import { apiCheckLogin } from "../api/users";
import NoAccess from "./NoAccess";

const PrivateRoute = ({ roles }) => {
    const { setUser, setIsAuthenticated } = useAppContext();
    const [loading, setLoading] = useState(true);
    const [isValid, setIsValid] = useState(false);
    const [isAllowed, setIsAllowed] = useState(false);
    const [redirectToCreateCompany, setRedirectToCreateCompany] = useState(false);

    const location = useLocation();

    useEffect(() => {
        const check = async () => {
            await apiCheckLogin(
                () => {
                    setIsAuthenticated(false);
                    setIsValid(false);
                    setLoading(false);
                },
                (userData) => {
                    setUser(userData);
                    setIsAuthenticated(true);
                    setIsValid(true);
                    setLoading(false);
                    console.log("userData: ", userData)
                    if (userData.role === null && userData.company === null) {
                        setRedirectToCreateCompany(true);
                        return;
                    }
                    if (roles.includes(userData.role)) {
                        setIsAllowed(true)
                    } else {
                        setIsAllowed(false)
                    }
                }
            );
        };

        check();
    }, [location.pathname]);

    if (loading) return null; // or a spinner/loader

    if (!isValid) {
        return <Navigate to="/landingPage" replace />;
    }

    if (redirectToCreateCompany) {
        return <Navigate to="/createUserCompany" replace />;
    }

    if (!isAllowed) return <NoAccess />;

    return isValid ? <Outlet /> : <Navigate to="/landingPage" replace />;
};

export default PrivateRoute;
